export const environment = {
  production: false,
  apiBaseUrl: 'https://uat-api.retailray.co.za',
  socketBaseUrl: 'wss://uat-api.retailray.co.za'
};



// WEBPACK FOOTER //
// /opt/build/repo/src/environments/environment.ts